<template>
  <transition
    name="ljb-loading-fade"
    @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      :style="{ backgroundColor: background || '' }"
      :class="[customClass, { 'is-fullscreen': fullscreen }]"
      class="ljb-loading-mask">
      <div class="ljb-loading-spinner">
        <img 
          src="https://cdn.51ljb.cn/ljb_bicon_home.png"
          style="width: 80px;margin-bottom: 5px;">
        <p
          v-if="text"
          class="ljb-loading-text"
          style="margin-bottom: 5px;">{{ text }}</p>
        <svg
          class="circular"
          viewBox="25 25 50 50">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"/>
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LjbLoading',
  props: {
    loadingText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      text: '律家保 | 您的，私家法律顾问',
      spinner: null,
      background: null,
      fullscreen: true,
      visible: true,
      customClass: ''
    }
  },
  methods: {
    handleAfterLeave () {
      this.$emit('after-leave')
    },
    setText (text) {
      this.text = text
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/LjbLoading.vue